// extracted by mini-css-extract-plugin
export default {"container_cadastro":"UsuarioCadastro_container_cadastro__VfIg0","div_titulo":"UsuarioCadastro_div_titulo__nT6-8","form_usuario":"UsuarioCadastro_form_usuario__Ug28S"};